// src/components/WorkOrdersSelector.jsx

import React, { useState, useEffect } from "react";
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Typography,
} from "@mui/material";
import axios from "axios";

const API_BASE_URL = "https://formbuilderapi.getforsite.com";

export default function WorkOrdersSelector({
  module,
  responses,
  handleChange,
  isEditable,
  companyId,
  qId,
}) {
  const [workOrders, setWorkOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!companyId || !qId) {
      // we don’t have the IDs yet
      return;
    }
    setError(""); // clear any previous error
    setLoading(true);
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/api/work-orders`, {
        params: {
          company_id: companyId,
          questionnaire_id: qId,
        },
      })
      .then(({ data }) => {
        setWorkOrders(data.workOrders || []);
      })
      .catch((err) => {
        console.error("Error fetching work orders:", err);
        setError("Failed to load work orders");
      })
      .finally(() => setLoading(false));
  }, [companyId, qId]);

  if (loading) return <CircularProgress size={24} />;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!workOrders.length) return <Typography>No work orders found.</Typography>;

  const selected = responses[module.id] || [];
  const toggle = (id) => {
    const next = selected.includes(id)
      ? selected.filter((x) => x !== id)
      : [...selected, id];
    handleChange(module.id, next);
  };

  return (
    <FormControl
      component="fieldset"
      margin="normal"
      disabled={!isEditable}
      fullWidth
    >
      <FormLabel component="legend">{module.label}</FormLabel>
      <FormGroup>
        {workOrders.map((wo) => {
          const labelText = wo.number
            ? `${wo.number} | ${wo.companyname}`
            : `Permit Request from ${wo.companyname}`;

          return (
            <FormControlLabel
              key={wo.id}
              control={
                <Checkbox
                  checked={selected.includes(wo.id)}
                  onChange={() => toggle(wo.id)}
                />
              }
              label={labelText}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
}
